<h2 id="title" class="subheading-01-bold">
  Esta accion no se puede revertir, se borraran todos los registros de
  movimientos del modulo de cuentas corrientes. ¿Desea Proceder?
</h2>
